import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import AdministracionScreen from ".";
import ListarMascota from "./gestionar-mascota/listar-mascota";
import Mascota from "./gestionar-mascota/mascota";
import Cuenta from "./administrar-cuenta/cuenta";
import MascotaRefugio from "./gestionar-mascota/mascota-refugio";
import QR from "./administrar-qr/qr";
import Publicidad from "./publicidad/publicidad";
// import MascotaRefugio from "./gestionar-mascota/mascota-refugio";

const RouterAdministracion = () => {
  const { path } = useRouteMatch();
  console.log('path', path);
  return (
    // <LayoutConfiguracion>
    <Switch>

      <Route exact path={`${path}`}>
        <AdministracionScreen />
      </Route>

      <Route exact path={`${path}/gestionar-mascota/listar-mascota`}>
        <ListarMascota />
      </Route>
      <Route exact path={`${path}/gestionar-mascota/mascota`}>
        <Mascota />
      </Route>
      <Route path={`${path}/gestionar-mascota/mascotarefugio`}>
        <MascotaRefugio />
      </Route>

      <Route exact path={`${path}/administrar-cuenta/cuenta`}>
        <Cuenta />
      </Route>

      <Route exact path={`${path}/administrar-qr/qr`}>
        <QR />
      </Route>

      <Route exact path={`${path}/publicidad/publicidad`}>
        <Publicidad />
      </Route>

    </Switch>
    // </LayoutConfiguracion>
  );
};

export default RouterAdministracion;
